// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3TJKJ","prodej":"styles_prodej__1ukwC","realizovano":"styles_realizovano__3Tzpt","pripravujeme":"styles_pripravujeme__7VZLn"};